module.exports = __webpack_public_path__ + "media/images/contest_voter_campaigns/banner-d2a8154a8d42f88767f23f702daf89ab.png";